/**
 * O contrato de mensagens entre a pagina e o service worker.
 *
 * Sao duas, e as duas tem nome normativo:
 *
 * - **`SKIP_WAITING`** (`PWA §5.2`, PWA-010) — a **unica** forma de o SW novo ativar. O
 *   `self.skipWaiting()` no evento `install` e proibido por regra de lint; ativar um SW novo
 *   enquanto a pagina antiga roda troca o backend de assets sob os pes de um bundle ja
 *   carregado, e o sintoma disso em producao e `ChunkLoadError`, tipicamente no clique de
 *   "Pagar".
 * - **`PURGE_USER_DATA`** (`PWA §7.5`, passo 6; nome canonico fixado em X-29 e
 *   `CONTRACTS §7.2`) — o logout mandando o SW apagar os caches `api-*`.
 *
 * DUVIDA: `CONTRACTS §7.2` diz que a mensagem de purga e "tipada em `packages/contracts`". Ela
 * ainda nao existe la (nao ha `pwa/` em `packages/contracts/src`). O tipo esta aqui, com o nome
 * canonico, e deve migrar para `@farmacia/contracts` quando o modulo entrar — o dia em que
 * `web-interno` ou o worker precisarem do mesmo literal.
 */

export const MENSAGEM_SKIP_WAITING = 'SKIP_WAITING' as const;
export const MENSAGEM_PURGE_USER_DATA = 'PURGE_USER_DATA' as const;

export interface MensagemSkipWaiting {
  readonly type: typeof MENSAGEM_SKIP_WAITING;
}

export interface MensagemPurgeUserData {
  readonly type: typeof MENSAGEM_PURGE_USER_DATA;
  /** O motivo entra na telemetria; `PWA §7.5` enumera os quatro. */
  readonly reason: 'LOGOUT' | 'ACCOUNT_SWITCH' | 'REVOKED' | 'KILL';
}

export type MensagemParaOSw = MensagemSkipWaiting | MensagemPurgeUserData;

/** Type guard — `event.data` de um `message` e `any` por definicao da plataforma. */
export function ehMensagemParaOSw(valor: unknown): valor is MensagemParaOSw {
  if (typeof valor !== 'object' || valor === null) return false;
  const tipo = (valor as { type?: unknown }).type;
  return tipo === MENSAGEM_SKIP_WAITING || tipo === MENSAGEM_PURGE_USER_DATA;
}

/**
 * Os caches que a purga apaga: **todo cache cujo nome comece com `api-`**.
 *
 * Prefixo, e nao a lista `['api-public-v1']`, porque o dia em que alguem acrescentar
 * `api-config-v2` o logout precisa leva-lo junto sem que ninguem se lembre deste arquivo. Os
 * caches de app, fonte, icone e imagem **nao** entram: nao tem dado de usuario, e apaga-los no
 * logout jogaria fora dezenas de MB de franquia ja paga por um logout que nao os torna
 * sensiveis.
 */
export const PREFIXO_DE_CACHE_DE_USUARIO = 'api-';

export function ehCacheDeUsuario(nome: string): boolean {
  return nome.startsWith(PREFIXO_DE_CACHE_DE_USUARIO);
}
